export function useToastContextValues_unstable(state) {
    const { backgroundAppearance } = state;
    return {
        backgroundAppearance
    };
}
